import i18n from '../i18n';

function getFormattedUniti18n(unit){
  if(unit==1){
    return i18n.t('products.units.Box');
  }else if(unit==2){
    return i18n.t('products.units.Unitary');
  }
}

export default {

  getPriceByCustomerClass (pricing, customerClassId) {
    let price = pricing;
    let priceByClass = _.find(pricing.pricesByClasses, pbc => pbc.customerClassId === customerClassId);
    if (priceByClass != null) {
      price = priceByClass
    }
    // console.log('My price :', price);
    return price;
  },
  formatBatchNumber (batchNumber, isIPInventory = false) {
    if (isIPInventory) {
      const splittedBatchNumber = _.split(batchNumber, '-');
      if (_.isArray(splittedBatchNumber) && splittedBatchNumber.length === 2 ) {
        return `+${splittedBatchNumber[1]}`;
      }
      return `+${batchNumber}`;
    }

    return batchNumber
  },
  getFormatLabel(volume, format){
    if (volume == null || format == null) return '';
    const formatLabel = format == 1 ? 'ml' : 'l';
    return `${volume} ${formatLabel}`;
  },
  getUnitFormatLabel(unit, uvc) {
    const uvcLabel = unit === 1 ? `${uvc}`: ``;
    if (unit === 2) {
      return `${getFormattedUniti18n(unit)}`;
    }
    return `${getFormattedUniti18n(unit)} (x${uvcLabel})`;
  },
  getSimpleProductName(product){
    return _.get(product, 'name');
  },
  // Obtient le nom du produit avec la référence du dernier lot
  getExtendedProductName(product, vintage = null) {
    let name = _.get(product, 'name');
    let sku = _.get(product, 'sku');
    if (_.get(product, 'type') === 0) return `${sku} - ${name}`;

    let reference = null;
    // S'il reste du stock sur en inventaire alors on va chercher l'information sur le top iitem
    if (_.get(product, 'quantity.inStock') > 0) {
      reference = vintage == null ? _.get(product, 'item.extraInfo.vintage') : vintage;
    } else if (_.get(product, 'quantity.pending') > 0 && product.itemToCome != null && product.itemToCome.extraInfo != null){
      // Sinon on va le chercher sur les produits à venir
      const extraInfo = this.convertPurchaseOrderExtraInfoToProductExtraInfo(product.itemToCome.extraInfo);
      reference = vintage == null ? _.get(extraInfo, 'vintage') : vintage;
    }

    if (reference != null) name = name + ' ' + reference;
    return name;
  },
  convertPurchaseOrderExtraInfoToProductExtraInfo (poExtraInfo) {
    const extraInfo = {};
    _.forEach(poExtraInfo, info => {
      extraInfo[_.lowerCase(info.code)] = info.value;
    })
    return extraInfo;
  },
  getVintageFromItem(item) {
    return _.get(item, 'extraInfo.vintage');
  },
  productName(product, type){

    if (type === 'cmsName') {
      return product.cmsName;
    }

    let name = product.sku + ' - ' + product.name;

    if(product.type==1){
      if (product.unit === 1) {
        name+= ' (' + product.uvc + ' x ';
      } else {
        name+= ' ( 1 x ';
      }
      
      name+= product.volume
      name+= product.format==1 ? 'ml)' : 'L)';
    }

    return name;
  }
}
